import React from 'react';
import { useLocation } from 'react-router-dom';
import { useCredit } from '../contexts/CreditContext';
import ProfessionalSubscriptionPopup from './ProfessionalSubscriptionPopup';

const CreditManager: React.FC = () => {
  const location = useLocation();
  const { 
    showLowCreditPopup, 
    setShowLowCreditPopup, 
    isBlocked 
  } = useCredit();

  // Não mostrar popup na página de checkout e evitar múltiplas renderizações.
  // No assistente e no editor o aviso fica para a próxima tela: a cobrança da geração cruzava o
  // limite de saldo e o aviso abria por cima da peça recém-gerada e da lista de revisão (no
  // celular cobria tudo). A revisão do assistente já mostra o saldo e o botão de recarregar.
  const inDocumentWork = location.pathname.startsWith('/documents/flow/') ||
                         location.pathname.startsWith('/documents/editor');
  const shouldShowPopup = showLowCreditPopup && 
                          location.pathname !== '/checkout' &&
                          !location.pathname.includes('/admin') &&
                          !inDocumentWork;
  
  const handleClose = () => {
    setShowLowCreditPopup(false);
  };

  return (
    <ProfessionalSubscriptionPopup
      open={shouldShowPopup}
      onClose={handleClose}
      isBlocked={isBlocked}
    />
  );
};

export default CreditManager; 